import React, { useEffect, useState } from 'react';
import BasicTable from '../../../../components/_atom/table/BasicTable';
import CopyToClipboard from 'react-copy-to-clipboard/lib';
import toast from 'react-hot-toast';
import iconCopy from '../../../dashboard/assets/Icon_copy_address.png';
import {
  TRANSFER_COLGROUP,
  TRANSFER_HEADERS,
  TRANSFER_RENDERER,
  APPROVAL_COLGROUP,
  APPROVAL_HEADERS,
  APPROVAL_RENDERER,
  HOLDER_COLGROUP,
  HOLDER_HEADERS,
  HOLDER_RENDERER,
  ENTRANCES_COLGROUP,
  ENTRANCES_HEADERS,
  ENTRANCES_RENDERER,
  GET_ROLES_COLGROUP,
  GET_ROLES_HEADERS,
  GET_ROLES_RENDERER,
  GET_ENTRANCES_COLGROUP,
  GET_ENTRANCES_HEADERS,
  GET_ENTRANCES_RENDERER,
  TRANSFER_HISTORY_ID,
  APPROVAL_HISTORY_ID,
  HOLDERS_ID,
  ENTRANCES_ID,
  GET_ROLES_ID,
  GET_ENTRANCES_ID,
  TABLE_RESULT_IDS,
} from './method.constant';
import { getBlockExplorerDetailAction } from '../../../../../action/blockExplorerAction';
import { Kit, KitFunctionMethod } from '../../../../assets/constant/kit.type';

const colgroup = (method_id: number) => {
  if (method_id === TRANSFER_HISTORY_ID) {
    return TRANSFER_COLGROUP;
  } else if (method_id === APPROVAL_HISTORY_ID) {
    return APPROVAL_COLGROUP;
  } else if (method_id === HOLDERS_ID) {
    return HOLDER_COLGROUP;
  } else if (method_id === ENTRANCES_ID) {
    return ENTRANCES_COLGROUP;
  } else if (method_id === GET_ROLES_ID) {
    return GET_ROLES_COLGROUP;
  } else if (method_id === GET_ENTRANCES_ID) {
    return GET_ENTRANCES_COLGROUP;
  }
  return [];
};
const headers = (method_id: number) => {
  if (method_id === TRANSFER_HISTORY_ID) {
    return TRANSFER_HEADERS;
  } else if (method_id === APPROVAL_HISTORY_ID) {
    return APPROVAL_HEADERS;
  } else if (method_id === HOLDERS_ID) {
    return HOLDER_HEADERS;
  } else if (method_id === ENTRANCES_ID) {
    return ENTRANCES_HEADERS;
  } else if (method_id === GET_ROLES_ID) {
    return GET_ROLES_HEADERS;
  } else if (method_id === GET_ENTRANCES_ID) {
    return GET_ENTRANCES_HEADERS;
  }
  return [];
};
const renderer = (method_id: number) => {
  if (method_id === TRANSFER_HISTORY_ID) {
    return TRANSFER_RENDERER;
  } else if (method_id === APPROVAL_HISTORY_ID) {
    return APPROVAL_RENDERER;
  } else if (method_id === HOLDERS_ID) {
    return HOLDER_RENDERER;
  } else if (method_id === ENTRANCES_ID) {
    return ENTRANCES_RENDERER;
  } else if (method_id === GET_ROLES_ID) {
    return GET_ROLES_RENDERER;
  } else if (method_id === GET_ENTRANCES_ID) {
    return GET_ENTRANCES_RENDERER;
  }
  return () => {};
};

type MethodResultProps = {
  method: KitFunctionMethod;
  kitDetail: Kit;
  result: any;
};
const MethodResult = (props: MethodResultProps) => {
  const { method, result, kitDetail } = props;
  const { method_id, need_wallet } = method;

  const [blockExplorerURL, setBlockExplorerURL] = useState<string>('');
  const getMicroChainExplorerURL = async () => {
    const { result, error } = await getBlockExplorerDetailAction(kitDetail.chain_id);
    const { mainStatus, isExternal, microChainId: chainId } = result;
    if (result) {
      if (isExternal && result.externalTransactionUrl) {
        setBlockExplorerURL(result.externalTransactionUrl);
        return;
      }
      if (!isExternal && mainStatus === 5) {
        setBlockExplorerURL(`${process.env.REACT_APP_EQ_FIELD_URL}/${chainId}/transaction/list`);
        return;
      }
    }
    if (error) {
      //TODO: error
    }
  };
  useEffect(() => {
    if (kitDetail?.chain_id) {
      getMicroChainExplorerURL();
    }
  }, [kitDetail]);
  return (
    <div className="method-result-wrapper">
      {TABLE_RESULT_IDS.includes(method_id) ? (
        Array.isArray(result) && result?.length > 0 ? (
          <BasicTable data={result} colGroup={colgroup(method_id)} headers={headers(method_id)} renderer={renderer(method_id)} />
        ) : (
          <div>No History yet</div>
        )
      ) : (
        <>
          {need_wallet && method_id !== 406 && method_id !== 40100 ? (
            <>
              <div className="method-result-text" style={{ marginBottom: 10 }}>
                Sent (Transaction Submitted)
              </div>
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'space-between',
                }}
              >
                <a className="method-result-text" href={`${blockExplorerURL}/${result}`} target={'_blank'} rel="noreferrer">
                  TX Hash : {JSON.stringify(result)}
                </a>
                <CopyToClipboard text={JSON.stringify(result)} onCopy={() => toast('Copied TX Hash', { icon: '👏' })}>
                  <img
                    src={iconCopy}
                    alt="copy"
                    style={{
                      width: 20,
                      height: 20,
                      objectFit: 'contain',
                      cursor: 'pointer',
                    }}
                  />
                </CopyToClipboard>
              </div>
              <div className="method-result-text" style={{ fontSize: 14 }}>
                Check the transaction status on the block explorer
              </div>
            </>
          ) : (
            <code style={{ whiteSpace: 'pre' }}>{JSON.stringify(result, null, 2)}</code>
          )}
        </>
      )}
    </div>
  );
};

export default MethodResult;
